export const checkFileSize = (
  file: { size?: number; name: string },
  maxSize?: number,
) => {
  if (file.size && maxSize) {
    const fileSizeMb = file.size / 1024 / 1024;
    if (fileSizeMb > maxSize) {
      throw Error(
        `Файл ${file.name}. Размер ${Math.round(fileSizeMb * 100) / 100} МБ превышает максимально допустимый (${maxSize} МБ)`,
      );
    }
  }
};
